import { render, staticRenderFns } from "./StorePage.vue?vue&type=template&id=9bdc36d4&scoped=true&"
import script from "./StorePage.vue?vue&type=script&lang=js&"
export * from "./StorePage.vue?vue&type=script&lang=js&"
import style0 from "./StorePage.vue?vue&type=style&index=0&id=9bdc36d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdc36d4",
  null
  
)

export default component.exports